var _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwoDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "198pt",
    height: "198pt",
    viewBox: "0 0 198 198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 26.75 -37.953125 C 24.5625 -37.953125 22.421875 -38.5 20.328125 -39.59375 C 18.234375 -40.695313 16.515625 -42.171875 15.171875 -44.015625 C 13.828125 -45.859375 13.15625 -47.820313 13.15625 -49.90625 C 13.15625 -53.195313 14.050781 -56.035156 15.84375 -58.421875 C 17.632813 -60.816406 20.175781 -62.015625 23.46875 -62.015625 C 25.65625 -62.015625 27.796875 -61.46875 29.890625 -60.375 C 31.984375 -59.28125 33.703125 -57.8125 35.046875 -55.96875 C 36.390625 -54.125 37.0625 -52.101563 37.0625 -49.90625 C 37.0625 -46.71875 36.164063 -43.925781 34.375 -41.53125 C 32.582031 -39.144531 30.039063 -37.953125 26.75 -37.953125 Z M 26.75 2.09375 C 24.5625 2.09375 22.421875 1.539063 20.328125 0.4375 C 18.234375 -0.65625 16.515625 -2.097656 15.171875 -3.890625 C 13.828125 -5.679688 13.15625 -7.625 13.15625 -9.71875 C 13.15625 -13.101563 14.050781 -15.960938 15.84375 -18.296875 C 17.632813 -20.640625 20.175781 -21.8125 23.46875 -21.8125 C 25.65625 -21.8125 27.796875 -21.265625 29.890625 -20.171875 C 31.984375 -19.078125 33.703125 -17.632813 35.046875 -15.84375 C 36.390625 -14.050781 37.0625 -12.007813 37.0625 -9.71875 C 37.0625 -6.53125 36.164063 -3.765625 34.375 -1.421875 C 32.582031 0.921875 30.039063 2.09375 26.75 2.09375 Z M 26.75 2.09375 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface246"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 73.724637,
    y: 132.24923
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoDots);
export default __webpack_public_path__ + "static/media/two-dots.fc0e475f60e97df3502d8a0e646272fb.svg";
export { ForwardRef as ReactComponent };